// eslint-disable-next-line import/prefer-default-export
export enum BillingInvoiceReportType {
  BANCO_BRASIL = 'BANCO_BRASIL',
  SANTANDER = 'SANTANDER',
  BRADESCO = 'BRADESCO',
  ITAU = 'ITAU',
}
